import { TownPage } from "./town-page";

export default function Franklin() {
  return (
    <TownPage
      town="Franklin"
      path="/service-areas/franklin"
      headline="Care for Franklin Properties"
      preserveFranklinProject
      description="TLC Associates LLC is based in Franklin, where local crews know the town's streets, seasons, and soil types. Downtown Franklin includes established homes, small businesses, and tree-lined sidewalks along East Central and West Central Streets. The Dean College area has mature shade trees, older homes, and single-family and multi-family properties. Oak Street and Forge Hill include spacious lots, wooded borders, stone walls, and open lawns, while Horace Mann and Mine Brook combine newer developments with established homes. Franklin properties receive responsive scheduling for year-round landscape care, from spring cleanup on Pond Street to a winter snow run on Lincoln Street. A typical drive from the shop is about five minutes, and crews live in the community they serve."
    />
  );
}